import { camelizeKeys, IS_NEW_BACKEND_API } from '@skytech/utils'
import { useQuery } from '@tanstack/react-query'

import { API_ROUTE_ADMIN_FEATURE_ACTIVE_CUSTOMERS } from '@/resources/api-routes'
import { get } from '@/util/auth'

export type FeatureCustomer = {
  customerId: number
  name: string
  active: boolean
}

export const useFeatureCustomers = (featureName: string) =>
  useQuery({
    queryKey: ['feature-customers', featureName],
    queryFn: async () => {
      const response = await get<unknown>(
        API_ROUTE_ADMIN_FEATURE_ACTIVE_CUSTOMERS.replace(':featureName', featureName),
        IS_NEW_BACKEND_API
      )
      return camelizeKeys(response) as FeatureCustomer[]
    },
    enabled: !!featureName,
  })
